import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";

export default function FloatingCTA() {
    const [visible, setVisible] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const wasDismissed = sessionStorage.getItem("sd_floating_dismissed") === "1";
        if (wasDismissed) return;
        const onScroll = () => {
            if (window.scrollY > 600) setVisible(true);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    function dismiss(e) {
        e.preventDefault();
        e.stopPropagation();
        sessionStorage.setItem("sd_floating_dismissed", "1");
        setDismissed(true);
    }

    if (!visible || dismissed) return null;

    return (
        <div
            className="fixed bottom-5 right-5 z-40 animate-fade-up lg:bottom-8 lg:right-8"
            data-testid="floating-cta"
        >
            <Link
                to="/#contact"
                className="group relative flex items-center gap-3 border-2 border-ink bg-coral px-4 py-3 font-display text-sm font-bold uppercase tracking-wider text-ink frame transition-all hover:-translate-y-0.5 hover:bg-coral-hover lg:px-5 lg:py-3.5"
                data-testid="floating-cta-link"
            >
                <span className="relative grid h-7 w-7 place-items-center bg-page text-coral">
                    <MessageCircle className="h-4 w-4" />
                    <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-sun" />
                </span>
                <span>Book a free 30-min chat</span>
                <button
                    onClick={dismiss}
                    aria-label="Dismiss"
                    className="grid h-6 w-6 place-items-center border border-ink/30 text-ink/70 hover:bg-page hover:text-coral"
                    data-testid="floating-cta-dismiss"
                >
                    <X className="h-3 w-3" />
                </button>
            </Link>
        </div>
    );
}
